<template>
  <div class="Login">
    <div class="header" v-if="!$store.state.mediaPhone">
      <link_wp :link="topLink[0]" :isBefore="1"></link_wp>
      <link_wp :link="topLink[1]"></link_wp>
    </div>
    <div class="form">
      <logo :logo="logo"></logo>
      <div class="title fs18">{{title}}</div>
      <my_button class="sendCode" :inputStyle="codeStyle" :value="scode" @click.native="sendCode"
                 :disable="!checkMobile() || codeDelay>0"></my_button>
      <my_input v-for="f in forms" :key="f.label" :type="f.type" :placeholder="f.placeholder" v-model="fm[f.label]"
                :error="error[f.label]"></my_input>
      <span :title="checkLogin()?'':'请先填写表单'"><my_button class="btn" :value="'确认'" @click.native="submit"
                                                               :disable="!checkLogin()"></my_button></span>
    </div>
  </div>
</template>

<script>
 import Logo from '@/components/Logo.vue';
 import MyLink from '@/components/Link.vue';
 import LinkWP from '@/components/LinkWithPseudo.vue';
 import MyInput from '@/components/Input.vue';
 import MyButton from '@/components/Button.vue';
 
 export default {
   name: 'Login',
   data () {
     return {
       scode: '发送验证码',
       codeDelay: 0,
       fm: {
         phone: '',
         code: ''
       },
       error: {
         phone: '',
         code: ''
       },
       reseting: false,
       btn: '登录',
     }
   },
   watch: {
     fm: {
       handler () {
         if(!this.reseting)
           this.resetError()
       },
       deep: true
     }
   },
   methods: {
     checkMobile () {
       if(!this.fm.phone)
         return false
       let patt = new RegExp(/^\d{11}$/);
       let res = patt.test(this.fm.phone)
       if(res)
         {
           this.error.phone=''
         }
       else
         {
           this.error.phone='phone syntax error'
         }
       return res
     },
     sendCode () {
       if(this.codeDelay)
         return;

       let data = new FormData();
       data.set('phone', this.fm.phone);
       this.$http.post('/api/login/send_code', data)
           .then(res => {
             let text = '重试'
             this.codeDelay = 60;
             let that = this;
             let loop = setInterval(function() {
               that.codeDelay -= 1
               that.scode = text+'('+that.codeDelay+')';
               if(that.codeDelay== 0)
                 {
                   that.scode='发送验证码';
                   clearInterval(loop);
                 }
             }, 1000);
           })
           .catch(e => {
             let error = e.response.data.errors
             this.reseting = true;
             for(let e in error)
               {
                 this.fm[e] = ''
                 this.error[e] = error[e]
               }
             this.$nextTick(()=>{
               this.reseting = false
             })
           })
     },
     
     resetError() {
       this.error = {
         phone: '',
         code: ''
       }
     },
     checkLogin() {
       return this.fm.phone && this.fm.code
     },
     submit() {
       this.btn = '登录中'
       let data = new FormData();
       data.set('phone', this.fm.phone);
       data.set('code', this.fm.code)
       this.$http.post('/api/login/by_code', data)
           .then(res => {
             this.$store.commit('SET_TOKEN', res.data);
             this.$http.get('/api/login/me')
                 .then(me => {
                   let user = me.data
                   this.$store.commit("SET_USER", user)
                   let classrooms = this.$http.get('/api/classroom');
                   let gameState = this.$http.get("/api/user/game_state");
                   Promise.all([classrooms, gameState])
                          .then(ress => {
                            let crs = ress[0].data
                            this.$store.commit("SET_CLASSROOMS", crs.classrooms)
                            this.$store.commit("SET_MY_CLASSROOM", crs.me_v2)
                            this.$store.commit("SET_GAME_STATE", ress[1].data)
                          })
                   .catch(e => {})
                   .then(res => {
                     this.$router.replace({name: 'account', params: {type: 'password'}})
                          })
                 })
           })
           .catch(e => {
             let error = e.response.data.errors
             this.btn = '登录'
             this.reseting = true;
             for(let e in error)
               {
                 this.fm[e] = ''
                 this.error[e] = error[e]
               }
             this.$nextTick(()=>{
               this.reseting = false
             })
           })
     }
   },
   computed: {
     codeStyle() {
       return {
         height: this.$store.state.mediaPhone? '25px': '1.8vw',
         width: '7em',
         'font-size': this.$store.state.mediaPhone? '12px': '0.73vw',
         'border-radius': '5px',
       }
     },

     topLink () {
       return this.$store.state.account.loginWithCode.links
     },
     logo(){
       return this.$store.state.logo.mainBlack
     },
     title () {
       return '忘记密码'
     },
     forms () {
       return this.$store.state.account.loginWithCode.forms
     },
     tips () {
       return {
         link: {
           text:'忘记密码?',
           link: {
           }
         },
         style: {
           color: '#3388FF'
         }
       }
     }
   },
   components: {
     my_input: MyInput,
     my_button: MyButton,
     my_link: MyLink,
     link_wp: LinkWP,
     logo: Logo
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Login {
   text-align: center;
   width: 32.08vw;
   height: 34.0625vw;
   background-color: white;

   box-sizing: border-box;
   padding-top: 1.32vw;
   padding-bottom: 1.2vw;
   padding-left: 3.18vw;
   padding-right: 3.18vw;

   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }

 .header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 1.5vw;
 }

 .form {
   position: relative;
 }

 .btn {
   margin-top: 0.99vw;
 }

 .title {
   color: #333333;
   margin-bottom: 12.57vw;
   margin-top: 1.875vw;
 }

 .sendCode {
   position: absolute;
   right: 1vw;
   /* top: 22.2vw; */
   bottom: 4.75vw;
 }

 .sendCode.disabled {
   background-color: grey;
 }


 @media (min-width: 320px) and (max-width: 480px) {
   .Login{
     width: 100vw;
     height: 100%;
     align-items:center;
     justify-content: center;
   }
   .form{
     height: 60%;
     width: 80%;
   }
   .title{
    margin-bottom: 6vh;
   }
  .btn{
   margin-top: 6vw;
    font-size: 12px;
 }

.sendCode {
   bottom: auto;
  top: calc(74px + 6vh);
 }
 }
</style>
